import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles Emergent Google OAuth callback.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refreshMe } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = loc.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } },
        );
      } catch (_e) {
        nav("/login", { replace: true });
        return;
      }
      // Clear the hash so we don't re-run
      window.history.replaceState(null, "", window.location.pathname);
      await refreshMe();
      nav("/app", { replace: true });
    })();
  }, []);

  return (
    <div className="grid min-h-[60vh] place-items-center text-muted-foreground">
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <div>Signing you in…</div>
      </div>
    </div>
  );
}
